<template>
  <div>
    <vm-table
        ref="vmTable"
        height="70vh"
        :filter.sync="filter"
        module="basic"
        url="baseMaterials">
      <div slot="toolbar">
        <el-button v-if="exportAuth" :loading="exportLoading" type="primary" @click="exportExcel()">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="物料编号">
            <el-input v-model.trim="filter.no" clearable/>
          </vm-search>
          <vm-search label="物料描述">
            <el-input v-model.trim="filter.name" clearable/>
          </vm-search>
          <vm-search label="物料组">
            <el-input v-model.trim="filter.materialGroupNO" clearable/>
          </vm-search>
          <vm-search label="采购类型">
            <el-select v-model.trim="filter.purchaseType" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.purchaseType)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="no" align="center" label="物料编号" width="90px"/>
      <el-table-column prop="name" align="center" label="物料描述" width="200px"/>
      <el-table-column prop="materialGroupNO" align="center" label="物料组" width="60px"/>
      <el-table-column prop="productGroupNO" align="center" label="产品组" width="60px"/>
      <el-table-column prop="purchaseGroupNO" align="center" label="采购组" width="60px"/>
      <el-table-column prop="purchaseType" align="center" label="采购类型" width="80px">
        <template slot-scope="scope">
          <span>{{purchaseTypes[scope.row.purchaseType]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="minStock" align="center" label="最低库存"/>
      <el-table-column prop="maxStock" align="center" label="最高库存"/>
      <el-table-column prop="mainProductionLine" align="center" label="主产线">
        <template slot-scope="scope">
          <span>{{productionLines[scope.row.mainProductionLine]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="viceProductionLine" align="center" label="辅线">
        <template slot-scope="scope">
          <span>{{productionLines[scope.row.viceProductionLine]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="productionTime" align="center" label="工时" width="45px"/>
      <el-table-column prop="configurableFlag" align="center" label="是否可配置">
        <template slot-scope="scope">
          <el-tag>
            {{scope.row.configurableFlag === "X" ? "是":"否"}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="180px">
        <template slot-scope="scope">
          <el-button v-if="editAuth" type="primary" @click="$refs.materialFaultGuid.open(scope.row)">检验项维护</el-button>
          <el-button v-if="editAuth" type="primary" @click="replicationTable(scope.row)">复制检验项</el-button>
          <el-button v-if="editAuth" type="primary" @click="$refs.editMaterial.open(scope.row.id)">修改</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <material-guid-table ref="materialFaultGuid"/>
    <replication-table ref="replicationTable"/>
    <material-edit ref="editMaterial" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import MaterialGuidTable from "@/views/information/MaterialManagement/MaterialGuidTable";
  import ReplicationTable from "./ReplicationTable";
  import MaterialEdit from "@/views/information/MaterialManagement/MaterialEdit";
  import constant from "../../../util/constant";

  export default {
    name: "MaterialManagementList",
    components: {MaterialEdit, ReplicationTable, MaterialGuidTable, VmTable, VmSearch},
    data() {
      return {
        constant,
        exportLoading: false,
        productionLines: constant.productionLine,
        purchaseTypes: constant.purchaseType,
        show: "",
        editAuth: this.$auth(739),
        exportAuth: this.$auth(740),
        filter: {
          no: "",
          name: "",
          materialGroupNO: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      replicationTable(row) {
        this.$http
          .get("basic", `sAPMaterialInspections/materialId/${row.id}`)
          .then((res) => {
            console.log(res);
            if (res.length>0) {
              this.$refs.replicationTable.open(row);
            }else {
              this.$message.error("未添加检验项");
            }
          }).catch(() => {
            this.$message.error("获取检验项失败");
          });
      },
      //导出
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","baseMaterials/exportMaterial", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
